// Utils
import { component } from 'picoapp';

import { flagDE, flagDK, flagGB, flagNO, flagSE, flagUS } from 'utils/icons';

import { MODAL_OPEN } from '../events';

export default component(async (node, ctx) => {
  const shops = [
    {
      url: 'shapingnewtomorrow.myshopify.com',
      country: 'gb',
      name: theme.strings.language.english,
    },
    {
      url: 'sntstoredk.myshopify.com',
      country: 'dk',
      name: theme.strings.language.danish,
    },
    {
      url: 'shapingnewtomorrow1.myshopify.com',
      country: 'de',
      name: theme.strings.language.german,
    },
    {
      url: 'shapingnewtomorrow2.myshopify.com',
      country: 'se',
      name: theme.strings.language.swedish,
    },
    {
      url: 'shapingnewtomorrow-norway.myshopify.com',
      country: 'no',
      name: theme.strings.language.norwegian,
    },
    {
      url: 'shapingnewtomorrow-usa.myshopify.com',
      country: 'us',
      name: theme.strings.language.us,
    },
  ];

  const init = (intendedShop, currentShop) => {
    const getFlag = (code) => {
      switch (code) {
        case 'dk':
          return flagDK();

        case 'de':
          return flagDE();

        case 'se':
          return flagSE();

        case 'no':
          return flagNO();

        case 'us':
          return flagUS();

        default:
          return flagGB();
      }
    };

    // const list = node.querySelector('[data-list]');
    // const close = node.querySelector('[data-close]');
    // const modal = Modal(node);

    // modal.open();

    // close.addEventListener('click', () => {
    //   modal.close();
    // });

    const path = window.location.pathname + window.location.search;

    node.insertAdjacentHTML(
      'beforeend',
      `
      <li>
        <a href="https://${intendedShop.url}${path}" class="country-selector__item justify-center ">
          <span class='flex'>
            ${getFlag(intendedShop.country)}
          </span>
          <span class="theme-blackweek:text-black">${intendedShop.name}</span>
        </a>
      </li>

      <li>
        <a href="https://${currentShop.url}${path}" class="country-selector__item justify-center">
          <span class='flex'>
            ${getFlag(currentShop.country)}
          </span>
          <span class="theme-blackweek:text-black">${currentShop.name}</span>
        </a>
      </li>
    `,
    );

    ctx.emit(MODAL_OPEN, null, { id: 'region-switch-modal' });
  };

  const getIntendedShop = (code) => {
    let intended = shops.find((shop) => shop.country === code);

    if (!intended) {
      [intended] = shops;
    }

    return intended;
  };

  const getCurrentShop = () => {
    let current = shops.find((shop) => shop.url === Shopify.shop);

    if (!current) {
      [current] = shops;
    }

    return current;
  };

  const getCountry = async () => {
    localStorage.removeItem('country');
    let country = localStorage.getItem('country');

    if (!country) {
      const data = await fetch('https://get.geojs.io/v1/ip/geo.json').then((response) =>
        response.json(),
      );

      country = data.country_code.toLowerCase();
      localStorage.setItem('country', country);
    }

    return country;
  };

  if (localStorage.getItem('has_redirected') === null) {
    getCountry().then((country) => {
      const intendedShop = getIntendedShop(country);
      const currentShop = getCurrentShop();

      if (intendedShop !== currentShop) {
        init(intendedShop, currentShop);
      }
    });

    localStorage.setItem('has_redirected', 'yes');
  } else {
    node.remove();
  }
});
